import React, { useState, useEffect } from "react";
import "./signupforms.css";
import logoMain from "../../../assets/images/mainlogo.svg";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
// import { Stepone } from "./steps/Stepone";
// import { Steptwo } from "./steps/Steptwo";
// import { Stepfour } from "./steps/Stepfour";
// import { Stepthree } from "./steps/Stepthree";
// import { Stepfive } from "./steps/Stepfive";
// import { Stepsix } from "./steps/Stepsix";
// import { Stepnine } from "./steps/Stepnine";
// import { Steptwelve } from "./steps/Steptwelve";
import { useNavigate, useParams } from "react-router-dom";
import { validateProviderApi } from "../../../api/providerApi/providerApi";
import useEncryption from "../../../services/useEncryption";
import WelcomeProvider from "./greetingPage/WelcomeProvider";
import SignupCompletion from "./greetingPage/SignupCompletion";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Loader from "../../../helpers/loader/Loader";

// Initialize Stripe with your public key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY);

export const SignupForms = () => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState("1");
  const { encryptData, decryptData } = useEncryption();
  const { providerId } = useParams();
  const [showGreeting, setShowGreeting] = useState(true);
  const [completed, setCompleted] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const checkFormValidity = async () => {
      try {
        const response = await validateProviderApi(providerId);
        const decryptedData = decryptData(response?.data?.data);
        if (decryptedData.formIsValid === true) {
          setLoading(false);
        } else {
          navigate("/");
        }
      } catch (error) {
        console.error("Error fetching form validity:", error);
        navigate("/");
      }
    };

    checkFormValidity();
  }, []);

  const getTabClass = (tabIndex) => {
    if (parseInt(value) === tabIndex) {
      return "currentactive";
    } else if (parseInt(value) > tabIndex) {
      return "activeDone";
    }
    return "";
  };

  return (
    <>
      <Loader loading={loading} />
      {showGreeting ? (
        <WelcomeProvider setShowGreeting={setShowGreeting} />
      ) : completed ? (
        <SignupCompletion />
      ) : (
        <div className="signUpForms">
          <div className="signupCards">
            <div className=" w-100">
              <img className="signInlogo" src={logoMain} alt="logo" />
            </div>
            <div className="container">
              {/* <TabContext value={value}>
                <Tabs
                  className="mainTabsDesign"
                  aria-label="disabled tabs example"
                >
                  <Tab label="1" value="1" className={getTabClass(1)} />
                  <Tab label="2" value="2" className={getTabClass(2)} />
                  <Tab label="3" value="3" className={getTabClass(3)} />
                  <Tab label="4" value="4" className={getTabClass(4)} />
                </Tabs>
                <TabPanel value="1">
                  <Stepsix
                    value={value}
                    setValue={setValue}
                    setLoading={setLoading}
                  />
                </TabPanel>
                <TabPanel value="2">
                  <Stepone
                    value={value}
                    setValue={setValue}
                    setLoading={setLoading}
                  />
                </TabPanel>
                <TabPanel value="3">
                  <Steptwelve
                    value={value}
                    setValue={setValue}
                    setLoading={setLoading}
                  />
                </TabPanel>
                <TabPanel value="4">
                  <Elements stripe={stripePromise}>
                    <Steptwo
                      value={value}
                      setValue={setValue}
                      setCompleted={setCompleted}
                      setLoading={setLoading}
                    />
                  </Elements>
                </TabPanel>
              </TabContext> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
